import { PATH } from '@/constants/path';
import CustomTemplate from '@/pages/CustomTemplate';
import Dashboard from '@/pages/Dashboard';
import Pricing from '@/pages/Pricing';
import Settings from '@/pages/Settings';
import StoreVerification from '@/pages/StoreVerification';
import TermAndCondition from '@/pages/TermAndCondition';
import TermAndConditionSetup from '@/pages/TermAndConditionSetup';
import Translation from '@/pages/Translation';
import TranslationSetup from '@/pages/TranslationSetup';
import { Navigate, Route, Routes } from 'react-router-dom';

interface IRouter {
  path: string;
  element: React.ReactNode;
}

const router: Array<IRouter> = [
  {
    path: PATH.DEFAULT.pathname,
    element: <Dashboard />,
  },
  {
    path: PATH.POP_UP_CUSTOMIZATION.pathname,
    element: <StoreVerification />,
  },
  {
    path: PATH.SETTINGS.pathname,
    element: <Settings />,
  },
  {
    path: PATH.CUSTOM_TEMPLATE.pathname,
    element: <CustomTemplate />,
  },
  {
    path: PATH.TRANSLATION.pathname,
    element: <Translation />,
  },
  {
    path: `${PATH.TRANSLATION_SETUP.pathname}/:language/:id`,
    element: <TranslationSetup />,
  },
  {
    path: PATH.TERM_AND_CONDITION.pathname,
    element: <TermAndCondition />,
  },
  {
    path: PATH.TERM_AND_CONDITION_SETUP.pathname,
    element: <TermAndConditionSetup />,
  },
  {
    path: PATH.PRICING_PLAN.pathname,
    element: <Pricing />,
  },
];

function RenderRouter(): JSX.Element {
  return (
    <Routes>
      {router.map((item: IRouter) => (
        <Route key={item.path} path={item.path} element={item.element} />
      ))}
      <Route path="*" element={<Navigate to={PATH.DEFAULT} replace />} />
    </Routes>
  );
}
export default RenderRouter;
